<template>
    
</template>

<script>
    export default {
        name: "BannerLink",
        ata() {
            return {}
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            }
        },
        mounted() {
            const vm = this;
            var url = vm.$route.query.bannerUrl;

            $("#header").hide();
            $("#footer").hide();

            if (url == null || url == '') {
                return;
            } else {
                window.location.href = decodeURIComponent(url);
            }
        }
    }
</script>

<style scoped>

</style>